/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toTalkProps } from './translator/talk'
import { FetchUnread, PutReadRoom, PutReadTalk } from '@/infrastructure/network/Monitaro/requests/read'

export default class Read extends MonitaroGatewayBase {
  async FetchUnread() {
    const { reads } = await this.apiClient.request(new FetchUnread())
    return reads
  }

  async PutReadRoom(room: string) {
    const { read } = await this.apiClient.request(new PutReadRoom(room))
    return read
  }

  async PutReadTalk(id: string) {
    const { talk } = await this.apiClient.request(new PutReadTalk(id))
    return toTalkProps(talk)
  }
}
